import { TimeZoneModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

export class TimeZone extends DomainEntity<TimeZoneModelDto> {
    public static from(dto: TimeZoneModelDto): TimeZone {
        return new TimeZone(dto);
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get timeZoneId() {
        return this.dto.timeZoneId ?? 0;
    }

    public set timeZoneId(value: number) {
        this.dto.timeZoneId = value;
    }

    public get showCutOffTimeZone() {
        return this.dto.showCutOffTimeZone ?? false;
    }

    public set showCutOffTimeZone(value: boolean) {
        this.dto.showCutOffTimeZone = value;
    }
}
